import {
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    IconButton,
    HStack,
    Tooltip
} from '@chakra-ui/react';
import {
    FacebookShareButton,
    TwitterShareButton,
    PinterestShareButton,
    WhatsappShareButton,
    EmailShareButton,
    FacebookIcon,
    TwitterIcon,
    PinterestIcon,
    WhatsappIcon,
    EmailIcon
} from 'react-share';
import { FaShareAlt, FaCopy } from 'react-icons/fa';
import { useTranslation } from "react-i18next";
import { useAppToast } from "../../../hooks/useAppToast";

const SharePopover = ({ url, title }) => {
    const { t } = useTranslation("default");
    const toast = useAppToast();

    const copyLink = () => {
        navigator.clipboard.writeText(url);
        toast({
            title: t('share.success.copied'),
            status: 'success',
            duration: 2000,
            isClosable: true,
        });
    };

    return (
        <Popover placement="top-end">
            <PopoverTrigger>
                <IconButton
                    aria-label={t('action.share')}
                    icon={<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.75" y="0.75" width="30.5" height="30.5" rx="15.25" stroke="white" strokeWidth="1.5" />
                        <path d="M13.0517 17.1926C13.2312 16.8335 13.3326 16.4282 13.3326 15.9998C13.3326 15.5714 13.2312 15.1661 13.0517 14.807M13.0517 17.1926C12.783 17.7298 12.3407 18.1606 11.7966 18.4151C11.2525 18.6696 10.6384 18.733 10.0538 18.5949C9.46922 18.4569 8.94834 18.1255 8.57557 17.6545C8.20281 17.1835 8 16.6005 8 15.9998C8 15.3992 8.20281 14.8161 8.57557 14.3451C8.94834 13.8741 9.46922 13.5427 10.0538 13.4047C10.6384 13.2666 11.2525 13.33 11.7966 13.5845C12.3407 13.839 12.783 14.2698 13.0517 14.807M13.0517 17.1926L18.9468 20.14M13.0517 14.807L18.9468 11.8596M18.9468 20.14C18.6304 20.7727 18.5784 21.5051 18.8021 22.1762C19.0258 22.8473 19.507 23.4021 20.1397 23.7184C20.7725 24.0348 21.505 24.0868 22.1761 23.8631C22.8472 23.6394 23.402 23.1583 23.7184 22.5256C24.0348 21.8929 24.0868 21.1604 23.8631 20.4893C23.6394 19.8183 23.1582 19.2635 22.5255 18.9472C22.2122 18.7905 21.8711 18.6971 21.5217 18.6723C21.1723 18.6475 20.8214 18.6917 20.4891 18.8025C19.818 19.0261 19.2632 19.5073 18.9468 20.14ZM18.9468 11.8596C19.1035 12.1729 19.3203 12.4522 19.5849 12.6816C19.8495 12.911 20.1567 13.0861 20.489 13.1968C20.8212 13.3076 21.1721 13.3518 21.5214 13.3269C21.8708 13.302 22.2118 13.2086 22.5251 13.052C22.8383 12.8954 23.1176 12.6785 23.3471 12.414C23.5765 12.1494 23.7516 11.8422 23.8624 11.5099C23.9731 11.1777 24.0173 10.8269 23.9924 10.4776C23.9676 10.1282 23.8742 9.78723 23.7175 9.474C23.4011 8.84141 22.8464 8.3604 22.1753 8.13679C21.5043 7.91318 20.7719 7.96528 20.1393 8.28163C19.5066 8.59799 19.0256 9.15268 18.802 9.82368C18.5783 10.4947 18.6304 11.227 18.9468 11.8596Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>}
                    borderRadius="full"
                    bg="gray.800"
                    color="white"
                    _hover={{ bg: 'gray.700' }}
                    size="sm"
                />
            </PopoverTrigger>
            <PopoverContent w="auto" bg="white" borderRadius="md" boxShadow="lg">
                <PopoverBody>
                    <HStack spacing={3}>
                        <FacebookShareButton url={url} quote={title}>
                            <FacebookIcon size={32} round />
                        </FacebookShareButton>

                        <TwitterShareButton url={url} title={title}>
                            <TwitterIcon size={32} round />
                        </TwitterShareButton>

                        <PinterestShareButton url={url} media={url} description={title}>
                            <PinterestIcon size={32} round />
                        </PinterestShareButton>

                        <WhatsappShareButton url={url} title={title}>
                            <WhatsappIcon size={32} round />
                        </WhatsappShareButton>

                        <EmailShareButton url={url} subject={title} body={title}>
                            <EmailIcon size={32} round />
                        </EmailShareButton>

                        <Tooltip label={t('action.copy_link')}>
                            <IconButton
                                icon={<FaCopy />}
                                onClick={copyLink}
                                borderRadius="full"
                                bg="gray.400"
                                color="white"
                                _hover={{ bg: 'gray.500' }}
                                size="sm"
                                aria-label={t('action.copy_link')}
                            />
                        </Tooltip>
                    </HStack>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
};

export default SharePopover;
